import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";

/**
 * Wrapper: `<Tip label="..."><Button>...</Button></Tip>`
 * - Testo IT breve (max ~40 char)
 * - Delay 400ms (SI-002 UX: 300–500ms)
 * - `side` default = "top"
 * - Uses shadcn Tooltip (Radix). Provider is mounted app-wide in App.js.
 *
 * Also mirrors label to `title` on the child element for native hover fallback
 * (screen readers + browsers senza JS Radix).
 */
export default function Tip({ label, side = "top", children, asChild = true, delayMs = 400 }) {
  if (!label) return children;
  return (
    <Tooltip delayDuration={delayMs}>
      <TooltipTrigger asChild={asChild} data-tip-label={label}>
        {children}
      </TooltipTrigger>
      <TooltipContent side={side} className="bg-[color:var(--pxos-text-dark)] text-white text-xs px-2.5 py-1.5 rounded-md shadow-md max-w-[260px]">
        {label}
      </TooltipContent>
    </Tooltip>
  );
}
